import React from 'react';
import { ContentfulPage } from '../common/ContentfulPage';
import { contentfulPages } from '../../services/constants';

const TermsOfUseScreen = () => (
  <ContentfulPage contentfulKey={contentfulPages.TOS} />
);

export { TermsOfUseScreen };
